import _ from 'lodash';
const timeOfDay = () => {
  var today = new Date();
  var curHr = today.getHours();

  if (curHr < 12) {
    return 'Morning';
  } else if (curHr < 18) {
    return 'Afternoon';
  } else {
    return 'Evening';
  }
};

export const parseFirstName = (name) => {
  return parseFullName(name).firstName;
};

export const parseFullName = (
  name: string
): { firstName: string; lastName: string } => {
  let firstName: string;
  let lastName: string;

  // Handle cases like: "Shola & Mitesh", "Shola + Mitesh", "Shola and Mitesh".
  if (_.some([' & ', ' + ', ' and '], (val) => _.includes(name, val))) {
    firstName = name;
    lastName = '';
  } else {
    const parts = _.split(name, ' ');
    if (parts.length === 2) {
      firstName = parts[0];
      lastName = parts[1];
    } else if (parts.length === 3) {
      firstName = `${parts[0]} ${parts[1]}`;
      lastName = parts[2];
    } else {
      // fallback if there's only one identifiable part or we're off in mars
      firstName = name;
      lastName = name;
    }
  }

  return {
    firstName,
    lastName,
  };
};

const greetingHelper = (user) => {
  const tod = timeOfDay();
  if (!user) {
    return `Good ${tod}!`;
  } else {
    return `${tod}, ${parseFirstName(user.name)}.`;
  }
};

export default greetingHelper;
